import Step from './Step';

interface ApiStepDefinition {
  type: string;
  endpoint: string;
  headers?: Record<string, string>;
  params?: Record<string, string>;
  body?: Record<string, any>;
  auth?: any;
  timeout?: number;
  condition?: string;
}

class ApiStep extends Step {
  constructor(description: string, definition: ApiStepDefinition) {
    super("api", description, definition);
  }

  static fromJson(json: any): ApiStep {
    return new ApiStep(
      json.params?.description || '',
      json.params?.definition || {}
    );
  }
}

export default ApiStep;